import { apiFetch } from "../../services/api";

export interface DraftReplyRequest {
  emailSubject?: string;
  emailBody?: string;
  senderName?: string;
  senderEmail?: string;
}

export interface DraftReplyResponse {
  draft: string;
}

export async function generateDraftReply(
  request: DraftReplyRequest
): Promise<DraftReplyResponse> {
  const response = await apiFetch("/api/draft-reply", {
    method: "POST",
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(`Failed to generate draft reply: ${response.statusText}`);
  }

  return response.json();
}
